import { type AxiosError } from 'axios'

/**
 * Use custom function instead of `isAxiosError` from `axios` to avoid compilation warnings
 * during `middleware` build (uses `Edge Runtime`)
 */
export const apmIsAxiosError = (error: Error): error is AxiosError =>
  'isAxiosError' in error && error.isAxiosError === true
